import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import { InputText } from 'components';
import { t } from 'utils/getLiteral';

class CrudInputText extends PureComponent {
    handleClear = () => {
        const { input } = this.props;
        input.onChange('');
    };

    onBlur = () => {
        const { input, onBlur = () => null } = this.props;
        onBlur(input);
    };

    render() {
        const {
            input,
            placeholder = 'cfm_placeholder_type_value',
            readOnly,
            copiable,
            onFocus,
            dataTest,
            autoFocus,
            meta: { touched, error },
        } = this.props;
        const { name, value, onBlur, onFocus: onFocusInput, ...rest } = input;

        const cleanVal = value !== undefined && value !== null ? value.toString() : '';

        const hasError = touched && error;

        return (
            <Fragment>
                <InputText
                    placeholder={t(placeholder)}
                    autoComplete="off"
                    readOnly={readOnly}
                    copiable={copiable}
                    onClearClick={this.handleClear}
                    value={cleanVal}
                    onBlur={this.onBlur}
                    hasError={hasError}
                    name={name}
                    id={name}
                    onFocus={onFocus}
                    dataTest={dataTest}
                    autoFocus={autoFocus}
                    {...rest}
                />
                {hasError && error === 'Required' && (
                    <p className="crud-error-message">{t('cfm_label_required_field')}</p>
                )}
                {hasError && error && error.error === 'maxLength' && (
                    <p className="crud-error-message">
                        {t('cfm_error_text_too_long', [error.max])}
                    </p>
                )}
            </Fragment>
        );
    }
}

CrudInputText.propTypes = {
    input: PropTypes.shape({}).isRequired,
    meta: PropTypes.shape({}).isRequired,
    onBlur: PropTypes.func,
    onFocus: PropTypes.func,
    placeholder: PropTypes.string,
    readOnly: PropTypes.bool,
    copiable: PropTypes.bool,
    dataTest: PropTypes.string.isRequired,
};

export default CrudInputText;
